import React, { useEffect, useState } from "react";
import { FormGroup, Label } from "reactstrap";
import { useDropzone } from "react-dropzone";
import "./fileDropzone.css";

const FileDropzone = ({ field, formik }) => {
  const [dropZoneErr, setDropZoneErr] = useState("");
  const [selectedFile, setSelectedFile] = useState(
    formik.values[field.key] || null
  );

  console.log(formik.values[field.key]);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
    },
    onDrop: (acceptedFiles, rejectedFiles) => {
      if (rejectedFiles.length > 0) {
        setDropZoneErr("File must be .pdf");
        setSelectedFile(null);
        formik.setFieldValue(field.key, null);
      }
      if (acceptedFiles.length > 0) {
        setDropZoneErr("");
        setSelectedFile(acceptedFiles[0]);
        formik.setFieldValue(field.key, acceptedFiles[0]);
      }
    },
  });

  useEffect(() => {
    if (selectedFile !== formik.values[field.key]) {
      formik.setFieldValue(field.key, selectedFile);
    }
  }, [selectedFile, field.key]); //formik

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      formik.setFieldTouched(field.key, true, true);
      formik.setFieldError(field.key, null);
    }
  }, [acceptedFiles]);

  const handleCancel = (e) => {
    e.stopPropagation();
    formik.setFieldValue(field.key, null);
    setSelectedFile(null);
  };

  return (
    <FormGroup key={field.key}>
      {field.label && <Label>{field.label}</Label>}

      <div
        {...getRootProps({ className: "dropzone" })}
        className={`file-drop-zone ${
          dropZoneErr || (formik.touched[field.key] && formik.errors[field.key])
            ? "border-danger"
            : ""
        } `}
      >
        <i onClick={handleCancel} className="mdi mdi-close cancel"></i>

        <input {...getInputProps()} />

        <p>
          {selectedFile
            ? selectedFile.name
            : "Drag 'n' drop file here, or click to select a file"}
        </p>
      </div>

      {formik.values[field.key] && (
        <a
          href={formik.values[field.key]}
          className="text-info fw-bold text-end d-block mt-1"
        >
          Download
        </a>
      )}

      {dropZoneErr ? (
        <div className="text-danger file-dropzone-err">{dropZoneErr}</div>
      ) : formik.touched[field.key] && formik.errors[field.key] ? (
        <div className="text-danger file-dropzone-err">
          {formik.errors[field.key]}
        </div>
      ) : null}
    </FormGroup>
  );
};

export default FileDropzone;
